import { type Theme } from '@mui/material';
import useMediaQuery from '@mui/material/useMediaQuery';
import type { FC } from 'react';
import { SidebarCollapsable } from './SidebarCollapsable';
import { SidebarDrawer } from './SidebarDrawer';

interface Props {
  open: boolean;
  collapsed: boolean;
  onClose: () => void;
}

export const Sidebar: FC<Props> = ({ open, collapsed, onClose }) => {
  const lgUp = useMediaQuery((theme: Theme) => theme.breakpoints.up('lg'));

  if (lgUp) {
    return <SidebarCollapsable collapsed={collapsed} />;
  } else {
    return <SidebarDrawer open={open} onClose={onClose} />;
  }
};
